namespace TabAurous.Common {
    export interface Party {
        PartyId?: number;
        POSCustomerId?: number;
        LedgerName?: string;
        CustomerName?: string;
    }
}
